import { IUniversalTemplateReducer, IUniversalTemplate } from 'models/UniversalTemplate'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetUniversalTemplates,
  UniversalTemplatesFetching,
  UpdateUniversalTemplate,
  DeleteUniversalTemplate,
  ClearUniversalTemplates,
} from './actions'

const initialState: IUniversalTemplateReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const universalTemplatesReducer = (
  state = initialState,
  action: Action
): IUniversalTemplateReducer => {
  if (isType(action, GetUniversalTemplates)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateUniversalTemplate)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IUniversalTemplate>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteUniversalTemplate)) {
    const { payload } = action
    const { data, meta } = state
    const formattedArray = deleteFromArray<IUniversalTemplate>(data, payload)
    return {
      ...state,
      data: formattedArray,
      meta: {
        ...meta,
        pagination: {
          ...meta.pagination,
          count: meta.pagination ? meta.pagination.count - 1 : 0,
          total: meta.pagination ? meta.pagination.total - 1 : 0,
          per_page: meta.pagination?.per_page || 50,
          current_page: meta.pagination?.current_page || 1,
          total_pages: meta.pagination?.total_pages || 1,
          links: meta.pagination?.links || [],
        },
      },
    }
  }

  if (isType(action, UniversalTemplatesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  if (isType(action, ClearUniversalTemplates)) {
    return {
      meta: {
        code: 0,
        message: '',
      },
      isFetching: false,
      data: [],
    }
  }
  return state
}
